import { AGENT_CHAT } from "src/common/constants";
import { LinkI } from "src/types/Link";
import { AgentChatAction } from "../reducers/agentChat";

export const AGENT_CHAT_SET_DATA = `${AGENT_CHAT}_SET_DATA` as const;

export const setAgentChat = (payload: LinkI): AgentChatAction => ({
  type: AGENT_CHAT_SET_DATA,
  payload,
});
